import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=101e4454&scoped=true&"
import script from "./appFooter.vue?vue&type=script&lang=js&"
export * from "./appFooter.vue?vue&type=script&lang=js&"
import style0 from "./appFooter.vue?vue&type=style&index=0&id=101e4454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101e4454",
  null
  
)

export default component.exports